import { render, staticRenderFns } from "./MonetaryRewardSection.vue?vue&type=template&id=57081a6e&scoped=true&"
import script from "./MonetaryRewardSection.vue?vue&type=script&setup=true&lang=js&"
export * from "./MonetaryRewardSection.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./MonetaryRewardSection.vue?vue&type=style&index=0&id=57081a6e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57081a6e",
  null
  
)

export default component.exports